/* eslint-disable import/order */
import { aiEntitlementResource } from '@jira/router-resources__ai-entitlement/src/aiEntitlementResource.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { softwareCalendarClassicCustomEmbedRoute } from '@jira/router-routes__classic-projects-routes/src/softwareCalendarClassicCustomEmbedRoute.tsx';
import { CalendarEmbedSkeleton } from '@jira/platform__skeletons/src/ui/calendar/CalendarSkeleton.tsx';
import { chromelessLayout } from '@jira/platform__layouts-chromeless-layout/src/index.tsx';
import { jiraSpaResources } from '@jira/router-resources__spa-page-container/src/jiraSpaResources.tsx';
import { resourceWithCondition } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { getIssueViewResources } from '@jira/router-resources__issue-view/src/getIssueViewResources.tsx';
import { softwareCalendarRouteEntry } from './ui/software/calendar/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const softwareCalendarClassicCustomEmbedRouteEntry: Route = createEntry(
	softwareCalendarClassicCustomEmbedRoute,
	() => ({
		group: 'classic-software',
		skeleton: CalendarEmbedSkeleton,
		// eslint-disable-next-line no-restricted-syntax
		component: CalendarEmbedSkeleton,
		entryPoint() {
			return softwareCalendarRouteEntry;
		},
		layout: chromelessLayout,
		resources: [
			...getIssueViewResources(),
			...jiraSpaResources(),
			resourceWithCondition(() => fg('ai_sprint_goal_gate'), aiEntitlementResource),
		],
		ufoName: 'classic-calendar-embed',
		EXPERIMENTAL__shouldReload: ({ context, prevContext, pluginId }) => {
			if (fg('dfo_connectedtoissueaggquery')) {
				if (pluginId === 'resources-plugin') {
					return (
						context.match.url !== prevContext.match.url ||
						(context.query.selectedIssue !== undefined &&
							context.query.selectedIssue !== prevContext.query.selectedIssue)
					);
				}

				return context.match.url !== prevContext.match.url;
			}
			return context.match.url !== prevContext.match.url;
		},
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
